import { render, staticRenderFns } from "./downloadCenter.vue?vue&type=template&id=20795dbd&scoped=true"
import script from "./downloadCenter.vue?vue&type=script&lang=js"
export * from "./downloadCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20795dbd",
  null
  
)

export default component.exports